import React, {useState} from 'react';
import {Card, CardBody, CardTitle, Col, Container, Input, Label, Row} from "reactstrap";
import { connect } from 'react-redux';

import DateRangePicker from "../../../../../Components/Input/DateRangePicker";
import LoadingButton from "../../../../../Components/Buttons/LoadingButton";
import {CampaignLaunchStatus} from "../../../../../../Service/OPSServices/CampaignLaunchServices";
import CampaignLaunchStatusTable from "./Components/CampaignLaunchStatusTable";


function CampaignLaunchPage(props) {

    const [dateRange, setDateRange] = useState({
        startDate: null,
        endDate: null,
    });

    const [integerId, setIntegerId] = useState("");
    const [asin, setAsin] = useState("");

    const [loading, setLoading] = useState(false);

    const [campaignLaunchStatus, setCampaignLaunchStatus] = useState([]);

    const fetchCampaignLaunchStatus = () => {
        setLoading(true);

        let isProduct = asin !== "";

        let data = {
            startDate: dateRange.startDate,
            endDate: dateRange.endDate,
        };

        if (isProduct) {
            data["asin"] = asin;
        } else {
            data["integerId"] = integerId;
        }

        CampaignLaunchStatus(props.token, data).then(launchStatus => {
            if (launchStatus) {
                setCampaignLaunchStatus(launchStatus);
            }
        })

        setLoading(false);
    }

    const isInputValid = () => {
        if (dateRange.startDate === null) return false;
        //if (integerId === "" && asin === "") return false;
        //if (integerId !== "" && asin !== "") return false;

        return true;
    }

    return (
        <>
            <Container fluid>
                <Row className="mb-3">
                    <Col md="12" lg="6">
                        <Card className="main-card mb-3">
                            <CardBody>
                                <CardTitle>Date Range</CardTitle>
                                <DateRangePicker
                                    dateRange={dateRange}
                                    setDateRange={setDateRange}
                                />
                                <div className="divider"/>
                                <Label for={"storeID"}>Store Integer ID</Label>
                                <Input
                                    className="mb-3"
                                    id={"storeID"}
                                    value={integerId}
                                    onChange={(e) => setIntegerId(e.target.value)}
                                    placeholder="Enter Store ID"
                                />
                                <p>OR</p>
                                <Label for={"productASIN"}>Product ASIN</Label>
                                <Input
                                    id={"productASIN"}
                                    value={asin}
                                    onChange={(e) => setAsin(e.target.value)}
                                    placeholder="Enter Product ASIN"
                                />
                                {
                                    (asin !== "" && integerId !== "") &&
                                    <p className="text-danger mt-1">Please enter only one of the following: Product ASIN or Store ID.</p>
                                }
                                <LoadingButton
                                    className="mt-5"
                                    loading={loading}
                                    color={"primary"}
                                    onClick={fetchCampaignLaunchStatus}
                                    disabled={!isInputValid()}
                                >
                                    Submit
                                </LoadingButton>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <CardTitle>Campaign Launch Status</CardTitle>
                        <Card>
                            <CampaignLaunchStatusTable data={campaignLaunchStatus} />
                        </Card>
                    </Col>
                </Row>
            </Container>
        </>
    )
}

const mapStateToProps = state => ({
    token: state.loggedUser.token,
})


export default connect(mapStateToProps)(CampaignLaunchPage);